module.exports = __webpack_public_path__ + "staticfr/media/gif-dimen6.437469a5.gif";